export default async function(url) {
  const response = await fetch(url);
  const html = await response.text();
  return html;
}

